import { useQuery } from "react-query";
import { ObjectTagValuesConfiguration, ObjectTagValuesTypeEnum } from "../../services/object-tag-values-data-service/ConfigurationModels";
import ObjectTagValuesDataService from "../../services/object-tag-values-data-service/ObjectTagValuesDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseObjectTagValuesConfigurationParameters = {
    groupID: number,
    configurationID: number,
    viewType: ObjectTagValuesTypeEnum;
} & BaseUseQueryParameters<ObjectTagValuesConfiguration>;

export function useObjectTagValuesConfiguration({
    groupID,
    configurationID,
    viewType,
    enabled,
    onError,
    onSuccess
}: UseObjectTagValuesConfigurationParameters
) {
    return useQuery<ObjectTagValuesConfiguration | undefined, RestError>(
        keys.configuration(groupID, configurationID),
        async ({ signal }) => {
            if (configurationID > -1) {
                return ObjectTagValuesDataService.getConfiguration(
                    groupID,
                    configurationID,
                    signal
                );
            } else {
                return Promise.resolve(ObjectTagValuesDataService.createDefaultConfiguration(-1, viewType));
            }
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess,
            staleTime: Infinity,
            cacheTime: 0
        }
    );
}